// hooks/useIntro.js
import { useState } from 'react';
import axios from 'axios';

export const useIntro = () => {
  const [hasCompletedIntro, setHasCompletedIntro] = useState(null);
  const [showIntroQuiz, setShowIntroQuiz] = useState(false);
  const [introQuestions, setIntroQuestions] = useState([]);
  const [introVideoFileName, setIntroVideoFileName] = useState('');
  const [isLoadingIntro, setIsLoadingIntro] = useState(false);

  const checkIntroStatus = (doneIntro) => {
    setHasCompletedIntro(doneIntro);
    if (!doneIntro) {
      fetchIntroQuiz();
    }
  };

  const fetchIntroQuiz = async () => {
    setIsLoadingIntro(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get_module_questions`, { params: { module_id: 1}}
      );
      setIntroQuestions(res.data.questions);
      setIntroVideoFileName(res.data.video_filename);
      setShowIntroQuiz(true);
    } catch (err) {
      console.error('Error fetching intro quiz:', err);
    } finally {
      setIsLoadingIntro(false);
    }
  };

  const completeIntro = async (userId) => {

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/complete_intro`,
        { user_id: userId}
      );

      if (result.data.success) {
        setHasCompletedIntro(true);
        setShowIntroQuiz(false);
        return { success: true };
      }
      else {
        console.log('I am in Failure of CompleteIntro in useIntro.js')
      }
    } catch (err) {
      console.error('Error completing intro:', err);
      return { success: false, error: err };
    }
  };

  return {
    hasCompletedIntro,
    showIntroQuiz,
    introQuestions,
    introVideoFileName,
    isLoadingIntro,
    checkIntroStatus,
    completeIntro,
    setShowIntroQuiz
  };
};